import styled from 'styled-components';
import { FjStyles } from 'components/primitives';

export default styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  background-color: ${FjStyles.colors.authGray.hex()};
  color: ${FjStyles.colors.darkGray.hex()};
  height: auto;
  width: 100%;
  max-width: 340px;
  padding: 25px;
  box-sizing: border-box;
  box-shadow: 0 1px 10px 1px hsla(0, 0%, 65%, 0.5);
  border: 1px solid hsla(0, 0%, 65%, 0.3);

  *:focus {
    outline: 1px solid ${FjStyles.colors.teal.hex()};
  }

  .fj-input {
    &:first-child {
      margin: 15px 0 15px 0;
    }

    &:nth-child(2) {
      margin-bottom: 5px;
    }
  }

  .fj-link {
    font-size: 14px;
  }

  .fj-button {
    font-size: 16px;
    width: 100%;
  }

  .forgot-password {
    align-self: flex-end;
    margin-bottom: 20px;
  }

  .notification {
    padding: 10px;
    margin-bottom: 20px;
    font-size: 14px;

    &.error {
      background-color: ${FjStyles.colors.authErrorBackground.hex()}
      border: 1px solid ${FjStyles.colors.authErrorText.hex()}
      color: ${FjStyles.colors.authErrorText.hex()}
    }

    &.message {
      background-color: ${FjStyles.colors.authMessageBackground.hex()}
      border: 1px solid ${FjStyles.colors.authMessageText.hex()}
      color: ${FjStyles.colors.authMessageText.hex()}
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }
`;
